'use strict';
import {module} from '../app';

export function safeApply($scope, fn) {
  if (!$scope)
    return;

  let phase = $scope && $scope.$root && $scope.$root.$$phase;

  if (phase === '$apply' || phase === '$digest') {
    if (fn) {
      $scope.$eval(fn);
    }
  } else {
    if (fn) {
      $scope.$apply(fn);
    } else {
      $scope.$apply();
    }
  }
}

module.factory('safeApply', [
  function() {
    return safeApply;
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/services/safeApply.js